import {POSITION_ERROR, SERVICE_AREA} from './public';
import {host} from '@utils/hostConf';
import {isWeiXin, wxReady} from '@utils/weixin';
import {jsonp} from './baseRequest';

const qq = window.qq || {};
const wx = window.wx || {};

// 腾讯定位
export function getLocationByTxMap(successCb, failCb) {
  const geolocation = new qq.maps.Geolocation('RXWBZ-NYCC6-YQVSW-EE2GH-FIS63-QGBA5', 'gstzy');
  geolocation.getLocation(successCb, failCb, {failTipFlag: true});
}

// 获取定位城市code  没有则默认广州
export function getCityCode(location) {
  if (location && location.city) {
    const city = SERVICE_AREA.find(d => d.city.includes(location.city));
    return city ? city.code : '020';
  }
}

//腾讯地图逆地址解析
export function getCityByTX(coords) {
  const data = {
    location: `${coords.latitude},${coords.longitude}`,
    key: 'DNSBZ-Q4PEX-BOG4R-TDUQJ-JXQEQ-EFBXE', //simon
    output: 'jsonp',
  };
  return jsonp(`https://apis.map.qq.com/ws/geocoder/v1/`, data).then(res => res.result);
}

//wgs84坐标转为火星坐标
const translateCoords = ({lat, lng}) => {
  return fetch(
    `${host.map}ws/coord/v1/translate?locations=${lat},${lng}&type=5&key=DNSBZ-Q4PEX-BOG4R-TDUQJ-JXQEQ-EFBXE`
  )
    .then(resp => resp.json())
    .then(res => {
      console.log('转换坐标系返回', res);
      if (res.status === 0) {
        return res.locations[0];
      } else {
        return {};
      }
    });
};

//获取定位,定位后直接使用经纬度调用回调函数
//返回: {latitude, longitude}
export function getCoords(options = {timeout: 10}) {
  let location = new Promise((resolve, reject) => {
    if (isWeiXin()) {
      wxReady().then(() => {
        wx.getLocation({
          type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
          success: res => {
            console.log('微信获取定位成功', res);
            resolve(res);
            // var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
            // var longitude = res.longitude ; // 经度，浮点数，范围为180 ~ -180。
            // var speed = res.speed; // 速度，以米/每秒计
            // var accuracy = res.accuracy; // 位置精度
          },
          cancel: error => {
            console.log('微信获取定位失败', error);
            reject({
              code: 6,
              message: error.errMsg,
            });
          },
        });
      });
    } else if ('geolocation' in navigator) {
      /* 地理位置服务可用 */
      window.navigator.geolocation.getCurrentPosition(
        async function (pos) {
          let coords = await translateCoords({lat: pos.coords.latitude, lng: pos.coords.longitude});
          resolve({
            latitude: coords.lat,
            longitude: coords.lng,
          });
        },
        function (error) {
          reject(error);
        }
      );
    } else {
      /* 地理位置服务不可用 */
      reject({
        code: 5,
        message: POSITION_ERROR[5],
      });
    }
  });

  return Promise.race([
    location,
    new Promise((resolve, reject) => {
      setTimeout(() => {
        reject({code: 4, message: POSITION_ERROR[4]});
      }, options.timeout * 1000);
    }),
  ]);
}
